import React from "react";
import styles from "./index.module.scss";
import ClassNames from "classnames";

export default function PageContent({ indent, isPDFlow, ...props }) {
  return (
    <div
      className={ClassNames(
        styles.container,
        indent ? styles.defaultIndent : ""
      )}
      style={{ paddingBottom: isPDFlow ? "0" : "16px" }}
    >
      {props.children}
    </div>
  );
}
